import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SecurityService } from '../security/security.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
class AdminGuardService {
  private router = inject(Router);
  private securityService = inject(SecurityService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = this.securityService.getToken();
    
    if (!token || this.securityService.isTokenExpired()) {
      this.router.navigate(['/auth/login'], { 
        queryParams: { returnUrl: state.url } 
      });
      return false;
    }

    const userRoles = this.securityService.getUserRoles();
    const isAdmin = userRoles.includes(environment.ROLE_ADMIN) || 
                    userRoles.includes(environment.ROLE_SUPER_ADMIN);

    if (!isAdmin) {
      this.router.navigate(['/auth/accessdenied']);
      return false;
    }

    return true;
  }
}

export const adminGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(AdminGuardService).canActivate(route, state);
};

